import { applyTimeZone } from '../../utils/utils';
import { PERMISSION_DESCRIPTIONS, ROLE_NAMES } from '../../utils/permissions';

const ROLE_VALUES = {
    0: 'No',
    1: 'Membre', 
    2: 'Cap'
};

function formatChange(change) {
    const permissionName = PERMISSION_DESCRIPTIONS[change.permission]?.name || change.permission;
    const roleName = ROLE_NAMES[change.role] || change.role;
    const oldValue = ROLE_VALUES[change.old_value] || change.old_value;
    const newValue = ROLE_VALUES[change.new_value] || change.new_value;
    
    return {
        text: `${permissionName}: `,
        change: `${oldValue} → ${newValue}`,
        suffix: ` per al rol de ${roleName}`
    };
}

function RolePermissionsLogs({ logs, loading }) {
    return (
        <div className="logs-section">
            <style jsx>{`
                .logs-section {
                    margin-top: 60px;
                    background: #f8f9fa;
                    border-radius: 12px;
                    padding: 30px;
                }

                .logs-section h2 {
                    margin-bottom: 20px;
                    color: #333;
                }

                .logs-list {
                    max-height: 600px;
                    overflow-y: auto;
                }

                .log-entry {
                    background: white;
                    border-radius: 8px;
                    padding: 15px;
                    margin-bottom: 15px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
                }

                .log-header {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 10px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #e0e0e0;
                }

                .log-date {
                    color: #666;
                    font-size: 14px;
                }

                .log-changes {
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                }

                .log-change {
                    font-size: 14px;
                    color: #555;
                    line-height: 1.5;
                }

                .change-highlight {
                    background: #e3f2fd;
                    color: #1565c0;
                    padding: 2px 6px;
                    border-radius: 4px;
                    font-weight: 500;
                }

                .spinner {
                    width: 20px;
                    height: 20px;
                    border: 2px solid #f3f3f3;
                    border-top: 2px solid #28a745;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin: 0 auto;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>

            <h2>📋 Historial de canvis</h2>
            {loading ? (
                <div style={{ textAlign: 'center', padding: 20 }}>
                    <div className="spinner"></div>
                </div>
            ) : logs.length === 0 ? (
                <p style={{ textAlign: 'center', color: '#666' }}>
                    Encara no hi ha canvis registrats
                </p>
            ) : (
                <div className="logs-list">
                    {logs.map((log, index) => (
                        <div key={index} className="log-entry">
                            <div className="log-header">
                                <strong>{log.user_name}</strong>
                                <span className="log-date">
                                    {applyTimeZone(log.timestamp).format('DD/MM/YYYY HH:mm')}
                                </span>
                            </div>
                            <div className="log-changes">
                                {log.changes.map((change, i) => {
                                    const formatted = formatChange(change);
                                    return (
                                        <div key={i} className="log-change">
                                            {formatted.text}
                                            <span className="change-highlight">{formatted.change}</span>
                                            {formatted.suffix}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default RolePermissionsLogs; 